import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '62px'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 4,
    paddingTop: 8,
    paddingBottom: 8
  }
}))

export default useStyles
